import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useWatch } from 'react-hook-form';

export const Subtotal = ({ price }) => {
    const { control } = useFormContext();
    const quantity = useWatch({ control, name: 'quantity' }) || 1;
    const selectedAddOns = useWatch({ control, name: 'addOns' }) || [];
    const addOnTotal = selectedAddOns.reduce((sum, addOn) => {
        const addOnPrice = typeof addOn?.priceChange === 'number' ? addOn.priceChange : 0;
        return sum + addOnPrice;
    }, 0);

    const subTotal = quantity * price + addOnTotal;

    return (
        <>
            <span className='tw-text-[24px] tw-font-bold'>${parseFloat(subTotal).toFixed(2)}</span>
            <span className='tw-text-[14px]'>Excluding taxes and fees</span>
        </>
    );
};

Subtotal.propTypes = {
    price: PropTypes.number
};
